import { IconProps } from "./";
import Icon from "./assets/help_info_44.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon44HelpInfo(props: IconProps) {
  return <BaseIcon className="text-6xl" icon={<Icon />} {...props} />;
}
